import { ErrorsType } from "..";
import { Custom } from "./Custom";

interface Props {
    tasOccurrenceNumber?: string;
    isLoading: boolean;
    supportType?: string;
    customerComment: string;
    handleChangeComment: (comment: string) => void;
    diagnose: string;
    handleDiagnose: (diagnose: string) => void;
    repair: string;
    handleRepair: (repair: string) => void;
    analysisReason: string;
    handleAnalysisReason: (repair: string) => void;
    partName: string;
    handlePartName: (partName: string) => void;
    aeg: string;
    handleAeg: (aeg: string) => void;
    errors: ErrorsType;
    cancelComment: string
    handleCancelComment: (aeg: string) => void;
    vehicleQtd: string;
    handleVehicleQtd: (aeg: string) => void;
}

const AdditionalData = ({
    tasOccurrenceNumber,
    isLoading,
    customerComment,
    handleChangeComment,
    supportType,
    diagnose,
    handleDiagnose,
    repair,
    handleRepair,
    analysisReason,
    handleAnalysisReason,
    partName,
    handlePartName,
    aeg,
    handleAeg,
    errors,
    cancelComment,
    handleCancelComment,
    handleVehicleQtd,
    vehicleQtd
}: Props) => {

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-14 text-medium text-color-black">2. Dados adicionais</span>
            </div>
            <div className="width-100pct display-flex flex-row gap-20">
                <Custom.Input label='Número do contrato*' value={tasOccurrenceNumber} disabled={true} isLoading={isLoading} />

                {supportType === "CONTRACT_CANCELLATION" ? (
                    <>
                        <Custom.Input
                            label='Quantidade de veículos*'
                            value={vehicleQtd}
                            isLoading={isLoading}
                            onChange={handleVehicleQtd}
                            error={errors.vehicleQtd}
                        />

                        <Custom.Input
                            label='Motivo do cancelamento*'
                            value={cancelComment}
                            isLoading={isLoading}
                            onChange={handleCancelComment}
                            error={errors.cancelComment}
                        />
                    </>
                ) : null}

                {supportType === "TECHNICAL" ? (
                    <>
                        <Custom.Input
                            label='Nome da peça causadora*'
                            value={partName}
                            isLoading={isLoading}
                            onChange={handlePartName}
                            error={errors.partName}
                        />
                        <Custom.Input
                            label='Nº AEG*'
                            value={aeg}
                            isLoading={isLoading}
                            onChange={handleAeg}
                            error={errors.aeg}
                        />
                    </>
                ) : null}
            </div>


            <div className="width-100pct">
                <Custom.TextArea
                    label={supportType === "TECHNICAL" ? "Qual a reclamação do cliente?*" : "Detalhe da solicitação"}
                    value={customerComment} onChange={handleChangeComment}
                    isLoading={isLoading}
                    error={errors.customerComment}
                />
            </div>

            {supportType === "TECHNICAL" ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label="Diagnóstico / causa da falha*"
                        value={diagnose}
                        onChange={handleDiagnose}
                        isLoading={isLoading}
                        error={errors.diagnose}
                    />
                    <Custom.TextArea
                        label="Reparo necessário*"
                        value={repair}
                        onChange={handleRepair}
                        isLoading={isLoading}
                        error={errors.repair}
                    />
                    <Custom.TextArea
                        label="Motivo do envio para análise*"
                        value={analysisReason}
                        onChange={handleAnalysisReason}
                        isLoading={isLoading}
                        error={errors.analysisReason}

                    />
                </div>
            ) : null}
        </div>
    )
}

export default AdditionalData;